import React from "react";
import { useTheme } from "@/context/ThemeContext";
import { useLang } from "@/i18n";
import { Moon, Sun, Languages } from "lucide-react";

export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggle}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-foreground transition-colors hover:bg-secondary ${className}`}
      aria-label="Toggle theme"
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}

export function LangToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <button
      data-testid="lang-toggle-btn"
      onClick={() => setLang()}
      className={`inline-flex h-9 items-center gap-1.5 rounded-full border border-border bg-card px-3 text-xs font-semibold uppercase tracking-wider text-foreground transition-colors hover:bg-secondary ${className}`}
      aria-label="Toggle language"
    >
      <Languages className="h-4 w-4" />
      {lang === "en" ? "EN" : "SQ"}
    </button>
  );
}
